import moment from 'moment/moment';

export const getCountDays = (pixelCount, date, activeTab = 'day') => {
    let resultDays = pixelCount / 25;

    if (activeTab === 'week') {
        resultDays = pixelCount / 11;
    }
    if (activeTab === 'month') {
        resultDays = pixelCount / 7;
    }

    return moment(date).add(Math.round(resultDays), 'days').format();
};

export const getMoveDays = (pixelCount, activeTab = 'day') => {
    let resultDays = pixelCount / 25;

    if (activeTab === 'week') {
        resultDays = pixelCount / 11;
    }
    if (activeTab === 'month') {
        resultDays = pixelCount / 7;
    }

    return Math.round(resultDays);
};

export const getUpdatePositions = (positions, diff, isFollower = false) => {
    const result = positions.map((position) => ({
        id: position.guid,
        changes: {
            ...position,
            planned: {
                ...position.planned,
                start_date: moment(position.planned.start_date)
                    [isFollower ? 'subtract' : 'add'](diff, 'days')
                    .format(),
                end_date: moment(position.planned.end_date)
                    [isFollower ? 'subtract' : 'add'](diff, 'days')
                    .format(),
            },
        },
    }));

    return result;
};

export const getCountDaysFromDate = (date1, date2) =>
    Math.abs(moment(date1).diff(moment(date2), 'days')) + 1;

export const getCountDaysFromDateResize = (date1, date2) =>
    Math.abs(moment(date1).diff(moment(date2), 'days')) - 1;

export const getStagePlanned = (date1, date2) =>
    Math.abs(moment(date1).diff(moment(date2), 'days')) + 1;
